module.exports = __webpack_public_path__ + "static/media/gb.85a97dab.svg";